import React from 'react'

export function NameValueColumn({
  name,
  value,
  className,
  valueClass,
  nameClass,
}: {
  name: string | JSX.Element
  value: string | JSX.Element | undefined
  className?: string
  valueClass?: string
  nameClass?: string
}) {
  return (
    <div className={className}>
      {typeof name === 'string' ? <div className={`small-header text-capital ${nameClass || ''}`}>{name}</div> : name}
      {typeof value === 'string' ? <div className={`text-main ${valueClass || ''}`}>{value}</div> : value}
    </div>
  )
}
